import { useEffect, useState } from 'react';

/**
 * Debounced loading, to avoid very brief flickers of loading animations on short operations
 * @param loading actual loading state
 * @param ms (optional) loading state update delay in milliseconds, default is 50
 * @param disableDebounceLoadStart (optional) disable debounce for the start of the loading state, default is false
 * @returns debounced loading state
 */
export const useDebouncedLoading = (
  loading: boolean,
  ms = 50,
  disableDebounceLoadStart = false
) => {
  const [delayedLoading, setDelayedLoading] = useState<boolean>(loading);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDelayedLoading(loading);
    }, ms);

    return () => clearTimeout(timeoutId);
  }, [loading, ms]);

  return delayedLoading || (disableDebounceLoadStart && loading);
};
